import { create } from 'zustand';
import { CreateComercialTableType } from './types';

type State = {
  createComercialTableBody: CreateComercialTableType;
  isCreateComercialTable: boolean;
  productDetailingList: [];
};

type Actions = {
  setCreateComercialTableState: (name: string, data: any) => void;
  setCreateComercialTableCleanFilters: () => void;
  setCreateComercialTableBodyObj: (data: any, productData: any) => void;
  reset: () => void;
};

const initialState: State = {
  createComercialTableBody: {
    nome: '',
    local: '',
    ufs: [],
    canal: '',
    subCanal: '',
    regras: [
      {
        tipo: 'PERCENTUAL_TABELA_BASE',
        percentualIdeal: 0,
        descontoMaximo: 0,
      },
    ],
    limites: [
      {
        tipo: 'PERCENTUAL_TABELA_BASE',
        percentualMinimo: 0,
        percentualMaximo: 0,
      },
    ],
    produtosBase: [
      {
        idProduto: 0,
      },
    ],
    idTabelaBase: null,
  },
  productDetailingList: [],
  isCreateComercialTable: true,
};

export const useCreateComercialTableStore = create<State & Actions>(set => ({
  ...initialState,
  setCreateComercialTableState: (name, data) => {
    set(() => ({
      [name]: data,
    }));
  },
  setCreateComercialTableBodyObj: (data, productData) => {
    const products = productData?.map(item => ({
      idProduto: item.produtoComercial.produtoBase.id,
      percentual: item.produtoComercial.percentual,
      descontoMaximo: item.produtoComercial.descontoMaximo,
    })) || [{ idProduto: 0 }];

    const obj = {
      nome: data.tabela.nome,
      local: data.tabela.dadosVenda.local,
      ufs: data.tabela.ufs,
      canal: data.tabela.dadosVenda.canal,
      subCanal: data.tabela.dadosVenda.subCanal,
      regras: [
        {
          tipo: 'PERCENTUAL_TABELA_BASE',
          percentualIdeal: data.regras[0].percentualIdeal,
          descontoMaximo: data.regras[0].descontoMaximo,
        },
      ],
      limites: [
        {
          tipo: 'PERCENTUAL_TABELA_BASE',
          percentualMinimo: data.limites[0].percentualMinimo,
          percentualMaximo: data.limites[0].percentualMaximo,
        },
      ],
      produtosBase: products,
      idTabelaBase: data.tabela.idTabelaBase ?? null,
    };
    set(state => ({
      createComercialTableBody: {
        ...state.createComercialTableBody,
        ...obj,
      },
    }));
  },
  setCreateComercialTableCleanFilters: () => {
    set(state => ({
      createComercialTableBody: {
        ...state.createComercialTableBody,
        local: '',
        ufs: [],
        canal: '',
        subCanal: '',
      },
    }));
  },
  reset: () => {
    set(initialState);
  },
}));
